import { render, staticRenderFns } from "./SendUsersReminderEmailAction.vue?vue&type=template&id=cb3d1346&scoped=true&"
import script from "./SendUsersReminderEmailAction.vue?vue&type=script&lang=ts&"
export * from "./SendUsersReminderEmailAction.vue?vue&type=script&lang=ts&"
import style0 from "./SendUsersReminderEmailAction.vue?vue&type=style&index=0&id=cb3d1346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3d1346",
  null
  
)

export default component.exports